export default "https://statics.cloudfastin.top/static/v1.27.38.2/store/images/Facebook.png?e5950d81da40dbc71dfadb8f2d460dab";